import { inMemoryJWTService } from '~services/jwt.service';
import { isSuperAdminRole } from '~utils/user.util';

/**
 * Single source of truth for permission-key checks. SUPER_ADMIN always
 * bypasses, matching the pre-rollout role-based behaviour — every consumer
 * (`canAccessCapability`/`useCan`/`Can`) inherits this instead of
 * re-implementing its own bypass.
 */
export const canAccessByPermission = (requiredPermission: string): boolean => {
  if (isSuperAdminRole()) return true;

  const userPermissions = inMemoryJWTService.getUserInfo()?.fuzedashPermissions;

  if (!userPermissions) {
    // eslint-disable-next-line no-console
    console.warn(
      `[access] no permissions on token; denying "${requiredPermission}"`,
    );
    return false;
  }

  return userPermissions.includes(requiredPermission);
};
